import React from 'react';
import { CircularProgress, Backdrop } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

const Loader: React.FC = () => {
  // 🔥 Assuming you store loader visibility in redux: { ui: { loading: true/false } }
  const { showLoader } = useSelector((state: RootState) => state.common);

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 9999, // keep on top of everything
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
      open={showLoader}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Loader;
